import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from "react";
import { ButtonBase } from "@material-ui/core";
import styled from "styled-components";
var StyledButton = styled(ButtonBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tborder-radius: 50%;\n\tbackground: ", ";\n\tpadding: 8px;\n"], ["\n\tborder-radius: 50%;\n\tbackground: ", ";\n\tpadding: 8px;\n"])), function (props) { return (props.disabled ? "hsl(220,13%,22%)" : "hsl(221,61%,38%)"); });
var IconRoundButton = function (_a) {
    var Icon = _a.Icon, rest = __rest(_a, ["Icon"]);
    return React.createElement(StyledButton, __assign({}, rest), Icon);
};
export default IconRoundButton;
var templateObject_1;
//# sourceMappingURL=index.js.map